import {apiService} from '../apiService';

export const formAssignmentsService = apiService.injectEndpoints({
    endpoints: (builder) =>
        ({
            getFormStudentsAssignments: builder.query({
                query: (body) => ({
                    url: `/forms/${body.formId}/student-assignments`,
                    method: 'POST',
                    data: body,
                }),
                transformErrorResponse: (_) => ({message: 'Failed to retrieve form student assignments'}),
            }),
            getFormEmployeeAssignments: builder.query({
                query: (body) => ({
                    url: `/forms/${body.formId}/employee-assignments`,
                    method: 'POST',
                    data: body,
                }),
                transformErrorResponse: (_) => ({message: 'Failed to retrieve form employee assignments'}),
            }),
            getFormQuestionAssignment: builder.query({
                query: (formId) => ({
                    url: `/forms/${formId}/question-assignment`,
                    method: 'GET'
                }),
                transformErrorResponse: (_) => ({message: 'Failed to retrieve form QUESTION assignments'}),
            }),
            getRelatedFormQuestionAssignment: builder.query({
                query: (formId) => ({
                    url: `/forms/${formId}/question-assignment/related`,
                    method: 'GET'
                }),
                transformErrorResponse: (_) => ({message: 'Failed to retrieve form QUESTION assignments'}),
            }),
            createFormQuestionAssignment: builder.mutation({
                query: (body) => ({
                    url: '/forms/question',
                    method: 'POST',
                    data: body,
                })
            }),
            deleteFormQuestionAssignment: builder.mutation({
                query: ({id, formId}) => ({
                    url: `/forms/${formId}/question/${id}`,
                    method: 'DELETE'
                })
            }),
            deleteFormAssignments: builder.mutation({
                query: (body) => ({
                    url: '/forms/assignment',
                    method: 'DELETE',
                    data: body,
                })
            }),
            deleteFormStudentsAssignments: builder.mutation({
                query: (body) => ({
                    url: '/forms/assignment/students',
                    method: 'DELETE',
                    data: body,
                })
            }),
            createFormStudentAssignment: builder.mutation({
                query: (body) => ({
                    url: '/forms/student-assignment',
                    method: 'POST',
                    data: body,
                })
            }),
            createFormEmployeeAssignment: builder.mutation({
                query: (body) => ({
                    url: '/forms/employee-assignment',
                    method: 'POST',
                    data: body,
                })
            }),
            getExternalUserFormAssignments: builder.query({
                query: (body) => ({
                    url: `/forms/${body.formId}/assignments/external`,
                    data: body,
                }),
                transformErrorResponse: (_) => ({message: 'Failed to retrieve external user form assignments'}),
            }),
            createExternalUserFormAssignments: builder.mutation({
                query: (body) => ({
                    url: '/forms/assignments/external',
                    method: 'POST',
                    data: body,
                })
            }),
            deleteExternalUserFormAssignments: builder.mutation({
                query: (body) => ({
                    url: '/forms/assignments/external',
                    method: 'DELETE',
                    data: body,
                })
            }),
        }),
});

export const {
    useGetFormStudentsAssignmentsQuery,
    useGetFormEmployeeAssignmentsQuery,
    useCreateFormQuestionAssignmentMutation,
    useDeleteFormQuestionAssignmentMutation,
    useGetFormQuestionAssignmentQuery,
    useGetRelatedFormQuestionAssignmentQuery,
    useDeleteFormAssignmentsMutation,
    useDeleteFormStudentsAssignmentsMutation,
    useCreateFormStudentAssignmentMutation,
    useCreateFormEmployeeAssignmentMutation,
    useGetExternalUserFormAssignmentsQuery,
    useCreateExternalUserFormAssignmentsMutation,
    useDeleteExternalUserFormAssignmentsMutation
} = formAssignmentsService;
